export default "__VITE_ASSET__UetfLW3c__"